import { Practitioner } from "./practitioner";
import { Symptom } from "./symptom";

export class PractitionerSymptom {
    id: number;
    practitionerId: number;
    practitioner: Practitioner;
    symptomId: number;
    symptom: Symptom;
}
